'use strict';

var objectWithoutProperties = require('../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var withStyles = require('../../../../DesignSystem/Styles/withStyles.js');
var Grid = require('../../../../DesignSystem/Layout/Grid/Grid.js');
var Typography = require('../../../../DesignSystem/DataDisplay/Typography/Typography.js');
require('prop-types');
var Star = require('../../../../IconsAndImages/Icons/Star.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    cardWidth: {
      width: 115
    },
    cardContainer: {
      position: 'relative',
      height: 115,
      marginLeft: 16
    },
    cardContentStyle: {
      padding: '0 16px 16px 16px',
      marginTop: -4
    },
    starPosition: {
      position: 'relative',
      top: 4
    },
    overallRatingsHeader: {
      margin: '14px 0 6px 0'
    }
  };
};

var ReviewsOverallSummaryCard = function ReviewsOverallSummaryCard(_ref) {
  var classes = _ref.classes;
      _ref.icon;
      _ref.reviewSiteBrandColor;
      var overallRating = _ref.overallRating,
      totalRatings = _ref.totalRatings;
      objectWithoutProperties(_ref, ["classes", "icon", "reviewSiteBrandColor", "overallRating", "totalRatings"]);

  return React__default["default"].createElement("div", {
    className: classes.cardWidth
  }, React__default["default"].createElement("div", {
    className: classes.cardContainer
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(Typography, {
    variant: "body1",
    color: "textSecondary",
    className: classes.overallRatingsHeader
  }, "Overall")), React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(Typography, {
    variant: "h5",
    color: "textSecondary"
  }, overallRating, " ", React__default["default"].createElement("span", {
    className: classes.starPosition
  }, React__default["default"].createElement(Star, {
    style: {
      fill: '#757575'
    }
  })))), React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, totalRatings, " reviews"))));
};

var ReviewsOverallSummaryCard$1 = withStyles["default"](styles)(ReviewsOverallSummaryCard);

module.exports = ReviewsOverallSummaryCard$1;
